import {
  CardGroup,
  TCardGroupProps,
} from '@/common/components/CardGroup/CardGroup';

export function CardActionGroup(cardGroupProps: TCardActionGroupProps) {
  return <CardGroup gap="2xs" {...cardGroupProps} />;
}

export type TCardActionGroupProps = Omit<TCardGroupProps, 'gap'>;
